export const countryCodes = [
  { code: '+971', country: 'UAE', flag: 'AE' },
  { code: '+963', country: 'Syria', flag: 'SY' },
  { code: '+966', country: 'Saudi Arabia', flag: 'SA' },
  { code: '+973', country: 'Bahrain', flag: 'BH' },
  { code: '+968', country: 'Oman', flag: 'OM' },
  { code: '+965', country: 'Kuwait', flag: 'KW' },
  { code: '+974', country: 'Qatar', flag: 'QA' },
  { code: '+20', country: 'Egypt', flag: 'EG' },
  { code: '+962', country: 'Jordan', flag: 'JO' },
  { code: '+961', country: 'Lebanon', flag: 'LB' },
  { code: '+964', country: 'Iraq', flag: 'IQ' },
  { code: '+1', country: 'USA', flag: 'US' },
  { code: '+44', country: 'UK', flag: 'GB' },
  { code: '+91', country: 'India', flag: 'IN' },
  { code: '+86', country: 'China', flag: 'CN' },
  { code: '+81', country: 'Japan', flag: 'JP' },
  { code: '+82', country: 'South Korea', flag: 'KR' },
  { code: '+55', country: 'Brazil', flag: 'BR' },
  { code: '+7', country: 'Russia', flag: 'RU' },
  { code: '+33', country: 'France', flag: 'FR' },
  { code: '+49', country: 'Germany', flag: 'DE' },
  { code: '+39', country: 'Italy', flag: 'IT' },
  { code: '+34', country: 'Spain', flag: 'ES' },
  { code: '+90', country: 'Turkey', flag: 'TR' },
  { code: '+92', country: 'Pakistan', flag: 'PK' },
  { code: '+63', country: 'Philippines', flag: 'PH' },
  { code: '+234', country: 'Nigeria', flag: 'NG' },
  { code: '+27', country: 'South Africa', flag: 'ZA' },
  { code: '+52', country: 'Mexico', flag: 'MX' },
  { code: '+54', country: 'Argentina', flag: 'AR' },
  { code: '+57', country: 'Colombia', flag: 'CO' },
  { code: '+48', country: 'Poland', flag: 'PL' },
  { code: '+380', country: 'Ukraine', flag: 'UA' },
  { code: '+62', country: 'Indonesia', flag: 'ID' },
  { code: '+60', country: 'Malaysia', flag: 'MY' },
  { code: '+66', country: 'Thailand', flag: 'TH' },
  { code: '+84', country: 'Vietnam', flag: 'VN' },
  { code: '+46', country: 'Sweden', flag: 'SE' },
  { code: '+31', country: 'Netherlands', flag: 'NL' },
  { code: '+41', country: 'Switzerland', flag: 'CH' },
  { code: '+61', country: 'Australia', flag: 'AU' },
  { code: '+64', country: 'New Zealand', flag: 'NZ' },
  { code: '+351', country: 'Portugal', flag: 'PT' },
  { code: '+30', country: 'Greece', flag: 'GR' },
  { code: '+36', country: 'Hungary', flag: 'HU' },
  { code: '+420', country: 'Czech Republic', flag: 'CZ' },
  { code: '+43', country: 'Austria', flag: 'AT' },
];
